import { FormItemController } from "./FormItemController";
import { Bool } from "../../HTML/Form/Item/Bool";
import { toMap } from "../../../../HA";

export class BoolController extends FormItemController {

    public isInputItem(): boolean {
        return true;
    }

    protected createItem() {
        const data = toMap({tag: this.getTag()});
        return new Bool(data);
    }
}
